import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Module from "./pages/Module";
import Activity from "./pages/Activity";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Credits from "./pages/Credits";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Account from "./pages/Account";
import Progress from "./pages/Progress";
import Journal from "./pages/Journal";
import ModuleLanding from "./pages/ModuleLanding";
import DeleteAccount from "./pages/DeleteAccount";
import ForgotPassword from "./pages/ForgotPassword";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route
        path="/credits"
        element={<Credits />}
      />

      <Route path="/module/:moduleId" element={<Module />} />
      <Route path="/activity/:activityId" element={<Activity />} />
      <Route
        path="/signup"
        element={<Signup />}
      />
      <Route
        path="/login"
        element={<Login />}
      />
      <Route
        path="/account"
        element={<Account />}
      />
      <Route
        path="/progress"
        element={<Progress />}
      />
      <Route
        path="/journal"
        element={<Journal />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPassword />}
      />
      <Route
        path="/:moduleId"
        element={<ModuleLanding />}
      />
      <Route
        path="/delete-account"
        element={<DeleteAccount />}
      />
    </Routes>



  );
}

export default App;